module.exports = __webpack_public_path__ + "img/1728437505167-Screenshot_9-10-2024_93129_www.bing.com.jpeg.7da8a1e2.webp";